import { Pipe, PipeTransform } from '@angular/core';
import { val } from '@uirouter/angular';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any, args: any): any {
    return value.filter(function(args){
        return value.code_type == args;
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/filter.pipe.ts